import styled from "styled-components";

export const getResponsiveStyle = (props: any, key: string, fallback: string = '') => {
  return props?.component_styles?.mobile?.[key]
    || props?.component_styles?.computer?.[key]
    || fallback;
}

export const Image = styled.div<any>`
min-width: ${props => props?.component_styles?.computer?.image_size || '200px'} !important;
  width: ${props => props?.component_styles?.computer?.image_size || '200px'} !important;
  height: ${props => props?.component_styles?.computer?.image_size || '200px'} !important;
  border-radius: ${props => props?.component_styles?.computer?.image_border_radius || '0px'} !important;

  background: url("${props => props?.src}") no-repeat center top;
  background-size: cover;

  @media (max-width: 750px) {
    width: ${props => getResponsiveStyle(props, 'image_size', '100%')} !important;
     height: ${props => getResponsiveStyle(props, 'image_size', '100%')} !important;
    border-radius: ${props => getResponsiveStyle(props, 'image_border_radius', '0px')} !important;
  }
`;

export const BigTitle = styled.h3<any>`
width: 100%;
  font-size: ${props => props?.component_styles?.computer?.big_title_size || '18px'} !important;
  line-height: ${props => props?.component_styles?.computer?.big_title_line_height || '22px'} !important;
  background: ${props => props?.component_styles?.computer?.big_title_background || 'none'} !important;  
  color: ${props => props?.component_styles?.computer?.big_title_color || 'none'} !important; 
  text-align: ${props => props?.component_styles?.computer?.big_title_text_align || 'left'} !important; 
  padding-bottom: 30px;

  @media (max-width: 750px) {
    font-size: ${props => getResponsiveStyle(props, 'big_title_size', '18px')} !important;
    line-height: ${props => getResponsiveStyle(props, 'big_title_line_height', '22px')} !important;
    background: ${props => getResponsiveStyle(props, 'big_title_background', 'none')} !important;
    color: ${props => getResponsiveStyle(props, 'big_title_color', 'none')} !important;
    text-align: ${props => getResponsiveStyle(props, 'big_title_text_align', 'left')} !important;
  }
`;

export const BigDescription = styled.h3<any>`
width: 100%;
  font-size: ${props => props?.component_styles?.computer?.big_description_size || '18px'} !important;
  line-height: ${props => props?.component_styles?.computer?.big_description_line_height || '22px'} !important;
  background: ${props => props?.component_styles?.computer?.big_description_background || 'none'} !important;  
  color: ${props => props?.component_styles?.computer?.big_description_color || 'none'} !important; 
  text-align: ${props => props?.component_styles?.computer?.big_description_text_align || 'left'} !important; 

  @media (max-width: 750px) {
    font-size: ${props => getResponsiveStyle(props, 'big_description_size', '18px')} !important;
    line-height: ${props => getResponsiveStyle(props, 'big_description_line_height', '22px')} !important;
    background: ${props => getResponsiveStyle(props, 'big_description_background', 'none')} !important;
    color: ${props => getResponsiveStyle(props, 'big_description_color', 'none')} !important;
    text-align: ${props => getResponsiveStyle(props, 'big_description_text_align', 'left')} !important;
  }
`;

export const Title = styled.h3<any>`
width: 100%;
  font-size: ${props => props?.component_styles?.computer?.title_size || '18px'} !important;
  line-height: ${props => props?.component_styles?.computer?.title_line_height || '22px'} !important;
  background: ${props => props?.component_styles?.computer?.title_background || 'none'} !important;  
  color: ${props => props?.component_styles?.computer?.title_color || 'none'} !important; 
  text-align: ${props => props?.component_styles?.computer?.title_text_align || 'left'} !important; 
    padding: ${props => props?.component_styles?.computer?.title_padding || '10px'} !important; 

  @media (max-width: 750px) {
    font-size: ${props => getResponsiveStyle(props, 'title_size', '18px')} !important;
    line-height: ${props => getResponsiveStyle(props, 'title_line_height', '22px')} !important;
    background: ${props => getResponsiveStyle(props, 'title_background', 'none')} !important;
    color: ${props => getResponsiveStyle(props, 'title_color', 'none')} !important;
    text-align: ${props => getResponsiveStyle(props, 'title_text_align', 'left')} !important;
        padding: ${props => getResponsiveStyle(props, 'title_padding', '10px')} !important;
  }
`;

export const Paragraph = styled.p<any>`
width: 100%;
  font-size: ${props => props?.component_styles?.computer?.description_size || '18px'} !important;
  line-height: ${props => props?.component_styles?.computer?.description_line_height || '22px'} !important;
  background: ${props => props?.component_styles?.computer?.description_background || 'none'} !important;  
  color: ${props => props?.component_styles?.computer?.description_color || 'none'} !important; 
  text-align: ${props => props?.component_styles?.computer?.description_text_align || 'left'} !important; 
  padding: ${props => props?.component_styles?.computer?.description_padding || '10px 15px'} !important; 
  @media (max-width: 750px) {
    font-size: ${props => getResponsiveStyle(props, 'description_size', '18px')} !important;
    line-height: ${props => getResponsiveStyle(props, 'description_line_height', '22px')} !important;
    background: ${props => getResponsiveStyle(props, 'description_background', 'none')} !important;
    color: ${props => getResponsiveStyle(props, 'description_color', 'none')} !important;
    text-align: ${props => getResponsiveStyle(props, 'description_text_align', 'left')} !important;
    padding: ${props => getResponsiveStyle(props, 'description_padding', '10px 15px')} !important;
  }
`;

export const TextContainer = styled.div<any>`
width: 100%;
  display: flex;
  flex-direction: ${props => props?.component_styles?.computer?.text_container_flex_direction || 'column'} !important;
  align-items: ${props => props?.component_styles?.computer?.text_container_align_items || 'flex-start'} !important;
  justify-content: ${props => props?.component_styles?.computer?.text_container_justify_content || 'flex-start'} !important;
  width: ${props => props?.component_styles?.computer?.text_container_width || '100%'} !important;
  padding: ${props => props?.component_styles?.computer?.text_container_padding || '24px'} !important;
  gap: ${props => props?.component_styles?.computer?.text_container_gap || '16px'} !important;
  background: ${props => props?.component_styles?.computer?.text_container_background || 'none'} !important;
  border: ${props => props?.component_styles?.computer?.text_container_border_radius || '0px'} !important;

  @media (max-width: 750px) {
    flex-direction: ${props => getResponsiveStyle(props, 'text_container_flex_direction', 'column')} !important;
    align-items: ${props => getResponsiveStyle(props, 'text_container_align_items', 'flex-start')} !important;
    justify-content: ${props => getResponsiveStyle(props, 'text_container_justify_content', 'flex-start')} !important;
    width: ${props => getResponsiveStyle(props, 'text_container_width', '100%')} !important;
    padding: ${props => getResponsiveStyle(props, 'text_container_padding', '24px')} !important;
    gap: ${props => getResponsiveStyle(props, 'text_container_gap', '16px')} !important;
    background: ${props => getResponsiveStyle(props, 'text_container_background', 'none')} !important;
    border: ${props => getResponsiveStyle(props, 'text_container_border_radius', '0px')} !important;
  }
`;

export const BlockContainer = styled.div<any>`
  display: flex;
  flex-direction: ${props => props?.component_styles?.computer?.container_flex_direction || 'row'} !important;
  align-items: ${props => props?.component_styles?.computer?.container_align_items || 'flex-start'} !important;
  justify-content: ${props => props?.component_styles?.computer?.container_justify_content || 'flex-start'} !important;
  width: ${props => props?.component_styles?.computer?.container_width || '100%'} !important;
  padding: ${props => props?.component_styles?.computer?.container_padding || '0px'} !important;
  gap: ${props => props?.component_styles?.computer?.container_gap || '5px'} !important;
  background: ${props => props?.component_styles?.computer?.container_background || 'none'} !important;
  border: ${props => props?.component_styles?.computer?.container_border || '0px'} !important;
  border-radius: ${props => props?.component_styles?.computer?.container_border_radius || '0px'} !important;

  @media (max-width: 750px) {
    flex-direction: ${props => getResponsiveStyle(props, 'container_flex_direction', 'column')} !important;
    align-items: ${props => getResponsiveStyle(props, 'container_align_items', 'flex-start')} !important;
    justify-content: ${props => getResponsiveStyle(props, 'container_justify_content', 'flex-start')} !important;
    width: ${props => getResponsiveStyle(props, 'container_width', '100%')} !important;
    padding: ${props => getResponsiveStyle(props, 'container_padding', '0px')} !important;
    gap: ${props => getResponsiveStyle(props, 'container_gap', '5px')} !important;
    background: ${props => getResponsiveStyle(props, 'container_background', 'none')} !important;
    border: ${props => getResponsiveStyle(props, 'container_border', '0px')} !important;
    border-radius: ${props => getResponsiveStyle(props, 'container_border_radius', '0px')} !important;
  }
`;

export const BlockContainerModal = styled.div<any>`
  display: flex;
  flex-direction: row  !important;
  align-items: ${props => props?.component_styles?.computer?.container_align_items || 'flex-start'} !important;
  justify-content: ${props => props?.component_styles?.computer?.container_justify_content || 'flex-start'} !important;
  width:   100% !important;
  padding: ${props => props?.component_styles?.computer?.container_padding || '24px'} !important;
  gap: ${props => props?.component_styles?.computer?.container_gap || '16px'} !important;
  background: ${props => props?.component_styles?.computer?.container_background || 'none'} !important;
  border: ${props => props?.component_styles?.computer?.container_border || '0px'} !important;
  border-radius: ${props => props?.component_styles?.computer?.container_border_radius || '0px'} !important;

  @media (max-width: 750px) {
    flex-direction:  column !important;
    align-items: ${props => getResponsiveStyle(props, 'container_align_items', 'flex-start')} !important;
    justify-content: ${props => getResponsiveStyle(props, 'container_justify_content', 'flex-start')} !important;
    width: 100% !important;
    padding: ${props => getResponsiveStyle(props, 'container_padding', '24px')} !important;
    gap: ${props => getResponsiveStyle(props, 'container_gap', '16px')} !important;
    background: ${props => getResponsiveStyle(props, 'container_background', 'none')} !important;
    border: ${props => getResponsiveStyle(props, 'container_border', '0px')} !important;
    border-radius: ${props => getResponsiveStyle(props, 'container_border_radius', '0px')} !important;
  }
`;